import { LoadStatus as LoadStatusEnum } from "@/types";
import { Colors } from "./theme";
import { ColumnDef } from "@/components/ui";

  const locationClasses = ["warehouse", "port"];
  const locationRequirement = [
    { id: 1, name: "Liftgate Service Needed",color:"#FFD200" },
    { id: 2, name: "Inside Pickup",color:"#FFD200" },
    { id: 3, name: "Appointment Required",color:"#FFD200" },
    { id: 4, name: "Driver Assist Required",color:"#FFD200" },
  ];
  // Enums for LoadStatus, LoadSize, and EquipmentType
const LoadStatus:{
  id: number;
  name: LoadStatusEnum;
  color: string;
}[] = [
  {id:1, name: LoadStatusEnum.PENDING,color:Colors.Pending},
  {id:2, name: LoadStatusEnum.IN_PROGRESS,color:Colors.InProgress},
  {id:3, name: LoadStatusEnum.DISPATCHED,color:Colors.Dispatched},
  {id:4, name: LoadStatusEnum.INSTRANSIT,color:Colors.PickedUp},
  {id:5, name: LoadStatusEnum.DELIVERED,color:Colors.Delivered},
  {id:6, name:LoadStatusEnum.INVOICES,color:Colors.Delivered},
  {id:7, name: LoadStatusEnum.CANCELLED,color:Colors.Cancelled},
  {id:8, name: LoadStatusEnum.Claimed,color:Colors.Claimed},
  {id:9, name: LoadStatusEnum.ClaimedDelivered,color:Colors.ClaimedDelivered},
]

// Status hierarchy disable rules based on API utility
// Maps current status to array of statuses that should be disabled for selection
export const STATUS_DISABLE_RULES: Record<LoadStatusEnum, LoadStatusEnum[]> = {
  [LoadStatusEnum.PENDING]: [LoadStatusEnum.INVOICES, LoadStatusEnum.ClaimedDelivered, LoadStatusEnum.DELIVERED, LoadStatusEnum.INSTRANSIT],
  [LoadStatusEnum.IN_PROGRESS]: [LoadStatusEnum.INVOICES, LoadStatusEnum.ClaimedDelivered, LoadStatusEnum.DELIVERED, LoadStatusEnum.INSTRANSIT],
  [LoadStatusEnum.DISPATCHED]: [LoadStatusEnum.INVOICES, LoadStatusEnum.ClaimedDelivered, LoadStatusEnum.DELIVERED, LoadStatusEnum.INSTRANSIT],
  [LoadStatusEnum.INSTRANSIT]: [LoadStatusEnum.INVOICES, LoadStatusEnum.ClaimedDelivered,LoadStatusEnum.DISPATCHED,LoadStatusEnum.IN_PROGRESS,LoadStatusEnum.PENDING],
  [LoadStatusEnum.DELIVERED]: [LoadStatusEnum.PENDING, LoadStatusEnum.IN_PROGRESS, LoadStatusEnum.DISPATCHED, LoadStatusEnum.INSTRANSIT, LoadStatusEnum.Claimed, LoadStatusEnum.CANCELLED,LoadStatusEnum.INVOICES,LoadStatusEnum.ClaimedDelivered],
  [LoadStatusEnum.Claimed]: [LoadStatusEnum.PENDING, LoadStatusEnum.IN_PROGRESS, LoadStatusEnum.DISPATCHED, LoadStatusEnum.INSTRANSIT, LoadStatusEnum.DELIVERED, LoadStatusEnum.CANCELLED, LoadStatusEnum.INVOICES],
  [LoadStatusEnum.ClaimedDelivered]: [LoadStatusEnum.PENDING, LoadStatusEnum.IN_PROGRESS, LoadStatusEnum.DISPATCHED, LoadStatusEnum.INSTRANSIT, LoadStatusEnum.DELIVERED, LoadStatusEnum.Claimed, LoadStatusEnum.CANCELLED, LoadStatusEnum.INVOICES],
  [LoadStatusEnum.INVOICES]: [LoadStatusEnum.PENDING, LoadStatusEnum.IN_PROGRESS, LoadStatusEnum.DISPATCHED, LoadStatusEnum.INSTRANSIT, LoadStatusEnum.DELIVERED, LoadStatusEnum.Claimed, LoadStatusEnum.ClaimedDelivered, LoadStatusEnum.CANCELLED],
  [LoadStatusEnum.CANCELLED]: [LoadStatusEnum.PENDING, LoadStatusEnum.IN_PROGRESS, LoadStatusEnum.DISPATCHED, LoadStatusEnum.INSTRANSIT, LoadStatusEnum.DELIVERED, LoadStatusEnum.Claimed, LoadStatusEnum.ClaimedDelivered, LoadStatusEnum.INVOICES]
}

// Helper function to get disabled statuses based on current status
export const getDisabledStatuses = (currentStatus?: LoadStatusEnum): string[] => {
  if (!currentStatus) return Object.values(LoadStatusEnum);
  return STATUS_DISABLE_RULES[currentStatus] || [];
}

// Helper function to check if a status should be disabled
export const isStatusDisabled = (statusName: LoadStatusEnum, currentStatus?: LoadStatusEnum): boolean => {
  const disabledStatuses = getDisabledStatuses(currentStatus);
  return disabledStatuses.includes(statusName);
}

const  LoadSize =[
  {id:"partial", name: 'Partial',color:Colors.Partial},
  {id:"full", name: 'Full',color:Colors.Full},
]
const tabs = ["load", "customer", "asset", "pickup", "delivery", "document"];
const EquipmentType=[
    {
      "category": "1. Dry Van",
      "options": [
        { "value": "Van", "label": "Van",color:Colors.Van },
        { "value": "Van - Air-Ride", "label": "Van - Air-Ride",color:Colors.VanAirRide },
        { "value": "Van - Hazardous", "label": "Van - Hazardous",color:Colors.VanHazardous },
        { "value": "Van - Vented", "label": "Van - Vented",color:Colors.VanVented },
        { "value": "Van w/ Curtains", "label": "Van w/ Curtains",color:Colors.VanCurtains },
        { "value": "Van w/ Pallet Exchange", "label": "Van w/ Pallet Exchange",color:Colors.VanPalletExchange }
      ]
    },
    {
      "category": "2. Temp. Control",
      "options": [
        { "value": "Reefer", "label": "Reefer",color:Colors.Reefer },
        { "value": "Reefer - Hazardous", "label": "Reefer - Hazardous",color:Colors.ReeferHazardous },
        { "value": "Reefer w/ Pallet Exchange", "label": "Reefer w/ Pallet Exchange",color:Colors.ReeferPalletExchange }
      ]
    },
    {
      "category": "3. Flatbed",
      "options": [
        { "value": "Double Drop", "label": "Double Drop",color:Colors.DoubleDrop },
        { "value": "Flatbed", "label": "Flatbed",color:Colors.Flatbed },
        { "value": "Flatbed - Hazardous", "label": "Flatbed - Hazardous",color:Colors.FlatbedHazardous },
        { "value": "Flatbed w/ Pallet Exchange", "label": "Flatbed w/ Pallet Exchange",color:Colors.FlatbedPalletExchange },
        { "value": "Flatbed w/ Sides", "label": "Flatbed w/ Sides",color:Colors.FlatbedSides },
        { "value": "Lowboy", "label": "Lowboy",color:Colors.Lowboy },
        { "value": "Maxi", "label": "Maxi",color:Colors.Maxi },
        { "value": "Removable Gooseneck", "label": "Removable Gooseneck",color:Colors.RemovableGooseneck },
        { "value": "Step Deck", "label": "Step Deck",color:Colors.StepDeck }
      ]
    },
    {
      "category": "4. Specialized",
      "options": [
        { "value": "Auto Carrier", "label": "Auto Carrier",color:Colors.AutoCarrier },
        { "value": "Dump Trailer", "label": "Dump Trailer",color:Colors.DumpTrailer },
        { "value": "Hopper Bottom", "label": "Hopper Bottom",color:Colors.HopperBottom },
        { "value": "Hotshot", "label": "Hotshot",color:Colors.Hotshot },
        { "value": "Tanker", "label": "Tanker",color:Colors.Tanker }
      ]
    },
    {
      "category": "5. Flexible Type",
      "options": [
        { "value": "Flatbed/Step Deck", "label": "Flatbed/Step Deck",color:Colors.FlatbedStepDeck },
        { "value": "Flatbed/Van", "label": "Flatbed/Van",color:Colors.FlatbedVan },
        { "value": "Flatbed/Reefer", "label": "Flatbed/Reefer",color:Colors.FlatbedReefer },
        { "value": "Reefer/Van", "label": "Reefer/Van",color:Colors.ReeferVan },
        { "value": "Flatbed/Reefer/Van", "label": "Flatbed/Reefer/Van",color:Colors.FlatbedReeferVan }
      ]
    },
    {
      "category": "Misc.",
      "options": [
        { "value": "Power Only", "label": "Power Only",color:Colors.PowerOnly }
      ]
    }
  ]
const LOAD_STATUSES: { key: string; label: LoadStatusEnum | string; color: string }[] = [
  { key: 'allLoad', label: 'All Loads', color: Colors.unknown },
  { key: LoadStatusEnum.PENDING, label: LoadStatusEnum.PENDING, color: Colors.Pending },
  { key: LoadStatusEnum.IN_PROGRESS, label: LoadStatusEnum.IN_PROGRESS, color: Colors.InProgress },
  { key: LoadStatusEnum.DISPATCHED, label: LoadStatusEnum.DISPATCHED, color: Colors.Dispatched },
  { key: LoadStatusEnum.INSTRANSIT, label: LoadStatusEnum.INSTRANSIT, color: Colors.InTransit },
  { key:"followup", label:"Follow Up", color: Colors.InTransit },
  { key:"billed", label:"Biils Ready", color: Colors.InTransit },
  { key: LoadStatusEnum.DELIVERED, label: LoadStatusEnum.DELIVERED, color: Colors.Delivered },
  { key: LoadStatusEnum.INVOICES, label: LoadStatusEnum.INVOICES, color: Colors.Invoiced },
  { key: LoadStatusEnum.ClaimedDelivered, label: LoadStatusEnum.ClaimedDelivered, color: Colors.ClaimedDelivered },
  { key: LoadStatusEnum.Claimed, label: LoadStatusEnum.Claimed, color: Colors.Claimed },
  { key: LoadStatusEnum.CANCELLED, label: LoadStatusEnum.CANCELLED, color: Colors.Cancelled },
];
const COLUMN_OPTIONS:ColumnDef[] = [
  { key: 'firstPickupDate', label: 'Pickup Date', color: Colors.loadNumber, sortable: true, disabled:true },
  { key: 'loadNumber', label: 'Load No',color:Colors.loadNumber ,sortable:true, disabled:true},
  { key: 'loadAmount', label: 'Load Amt',color:Colors.loadAmount ,sortable:true, disabled:true},
  { key: 'customerId', label: 'Customer',color:Colors.customer,sortable:true },
  { key: 'latestPickupDateTime', label: 'Origin',color:Colors.picks,sortable:true, disabled:true },
  { key: 'latestDeliveryDateTime', label: 'Destination',color:Colors.drops ,sortable:true, disabled:true},
  { key: 'currentLocation', label: 'Current Location',color:Colors.currentLocation ,sortable:true},
  { key: 'carrierIds.carrierPay', label: 'Carrier Pay',color:Colors.carrierPay,sortable:true },
  { key: 'carrierIds.margin', label: 'Margin Amt',color:Colors.unknown,sortable:true, disabled:true },
  { key: 'carrierIds.carrierTotal', label: 'carrier Total',color:Colors.unknown,sortable:true, disabled:true },
  { key: 'carrierIds.dipsatchRateAmt', label: 'Dispatch Rate Amt',color:Colors.dipsatchRateAmt,sortable:true },
  { key: 'carrierIds.carrier', label: 'Carrier',color:Colors.carrier,sortable:true },
  { key: 'carrierIds.assignDrivers', label: 'Driver',color:Colors.driver,sortable:true },
  { key: 'equipmentType', label: 'Equipment',color:Colors.equipment,sortable:true },
  { key: 'temperature', label: 'Temperature',color:Colors.unknown,sortable:true },
  { key: 'carrierIds.powerUnit', label: 'Power Unit',color:Colors.powerUnit,sortable:true },
  { key: 'carrierIds.trailer', label: 'Trailer',color:Colors.trailer,sortable:true },
  { key: 'createdBy', label: 'Created By',color:Colors.createdBy ,sortable:true, disabled:true},
  { key: 'status', label: "Status", align:'center', color:Colors.status,sortable:true, disabled:true },
] as const
export type COLUMN_OPTIONSTYPE = typeof COLUMN_OPTIONS[0]["key"][]

 const tempreatureEquipmentlist = EquipmentType.flatMap((type) =>
  type.options.filter((option) => (
    option.value.includes("Reefer")
  )).map((option) => (
    option.value
  ))
)

export  {locationClasses,tempreatureEquipmentlist,locationRequirement,LOAD_STATUSES,COLUMN_OPTIONS,LoadStatus,LoadSize,EquipmentType,tabs};